export class FilterButtonController {
    public static $inject: string[] = [
        "$mdComponentRegistry",
        "$mdSidenav",
        "$scope"
    ];
    private isFiltersDisplayed: boolean;

    constructor(
        $mdComponentRegistry,
        $mdSidenav,
        $scope
    ) {
        if (localStorage.getItem("isFiltersDisplayed")) {
            this.isFiltersDisplayed = localStorage.getItem("isFiltersDisplayed")
                ? true
                : false;
        }

        $scope.$watch(
            () => ($mdComponentRegistry.get("filternav") ? $mdSidenav("filternav").isOpen() : false),
            current =>
                current === true
                    ? localStorage.setItem("isFiltersDisplayed", current)
                    : localStorage.removeItem("isFiltersDisplayed")
        );
    }

    public toggle() {
        this.isFiltersDisplayed = !this.isFiltersDisplayed;
    }
}

